import styled from 'styled-components'
import OutlinedInputStyle from '@material-ui/core/OutlinedInput'
const Container = styled.div`
    margin-top: 1.1rem;
`

const DateRange = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: .3rem;
    >span {
        margin: 0 auto;
    }
    >.input_date{
        width: 45%;
        >div {
            padding: 0;
        }
        input {
            padding: .7rem 0 .7rem 14px;
            font-size: 14px;
        }
        svg {
            width: .7em;
        }
        button {
            padding: 5px;
            border-radius: 0;
        }
    }
`

export const OutlinedInput = styled(OutlinedInputStyle)`
  && {
    background: #FFFFFF;
    border-radius: 3px;
	input {
		font-size: 14px;
      	padding: 6px 12px;
    }
    >fieldset {
      border: none;
    }
    svg {
      cursor: pointer;
    }
  }
`

export {Container,DateRange}